import React from 'react';
import BeAds from '../components/solucionespublicitarias/BeAds';
import FormatDisplay from '../components/solucionespublicitarias/FormatDisplay';
import DisplayDesktop from '../components/solucionespublicitarias/DisplayDesktop';
import DisplayMobile from '../components/solucionespublicitarias/DisplayMobile';
import SponsorMode from '../components/solucionespublicitarias/SponsorMode';
import InventorySegmentations from '../components/solucionespublicitarias/InventorySegmentations';
import FormatVideo from '../components/solucionespublicitarias/FormatVideos';
import VideoStream from '../components/solucionespublicitarias/VideoStream';
import GeoreferencedCampaigns from '../components/solucionespublicitarias/GeoreferencedCampaigns';
import Content from '../components/solucionespublicitarias/Content';
import MicroSitesAndLandings from '../components/solucionespublicitarias/MicroSitesAndLandings';
import BehealthLive from '../components/solucionespublicitarias/BehealthLive';
import EmailMkt from '../components/solucionespublicitarias/EmailMkt';
import BehealthTv from '../components/solucionespublicitarias/BehealthTv';
import New2025 from '../components/solucionespublicitarias/New2025';
import PrintedFormats from '../components/solucionespublicitarias/PrintedFormats';
import EspecialEvents from '../components/solucionespublicitarias/EspecialEvents';

const SolucionesPublicitarias = () => {
    return (
        <div>
            <BeAds />
            <FormatDisplay />
            <DisplayDesktop />
            <DisplayMobile />
            <SponsorMode />
            <InventorySegmentations />
            <FormatVideo />
            <VideoStream />
            <GeoreferencedCampaigns />
            <Content />
            <MicroSitesAndLandings />
            <EmailMkt />
            <BehealthLive />
            <BehealthTv />
            <New2025 />
            <PrintedFormats />
            <EspecialEvents />
            
        </div>
    );
};

export default SolucionesPublicitarias;